import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const ReturnRefundPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <div className="container mb-5">
            {/* Breadcrumb Navigation */}
            <nav aria-label="breadcrumb" className="mt-4 mb-5">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/" className="text-dark text-decoration-none">
                            <i className="fas fa-home me-2"></i> Home
                        </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        <i className="fa-regular fa-folder me-2"></i> Return & Refund Policy
                    </li>
                </ol>
            </nav>

            <div >
                <div className="card-body">
                    <h1 className="text-left mb-4">Return & Refund Policy</h1>

                    <p>
                        Online Shop Matrix (“we,” “our,” or “us”) is committed to ensuring your satisfaction with your purchases.
                        We strive to provide clear and fair guidelines for returns, exchanges, and refunds.
                        Please read this policy carefully to understand your rights and our procedures.
                    </p>

                    <h3>1. Returns</h3>
                    <p>
                        Returns are accepted to ensure your satisfaction with purchased products. The following guidelines apply:
                    </p>
                    <ul>
                        <li>Products can be returned within 30 days of delivery from the date you receive your order.</li>
                        <li>Items must be unused, in their original packaging, and in the same condition as received.</li>
                        <li>Certain items, such as personalized products, digital goods, or perishable items, may not be eligible for return.
                            Check the product description for specific eligibility.</li>
                        <li>To initiate a return, contact our customer service at <strong>contact@onlineshopmatrix.com</strong>
                            or call <strong>+1 (574) 858-0288</strong>. We will provide instructions for returning your item safely.</li>
                    </ul>

                    <h3>2. Refunds</h3>
                    <p>
                        Refunds are processed once your returned items are received and inspected:
                    </p>
                    <ul>
                        <li>We will notify you of the approval or rejection of your refund via email.</li>
                        <li>Approved refunds will be applied to your original payment method within 7–10 business days, depending on your bank or payment provider.</li>
                        <li>Shipping fees are generally non-refundable, except when we send a defective, damaged, or incorrect item.</li>
                        <li>Refunds may take longer if additional verification is required for high-value items.</li>
                    </ul>

                    <h3>3. Exchanges</h3>
                    <ul>
                        <li>If you wish to exchange an item for the same product or a product of equal value, please contact our support team promptly.</li>
                        <li>Exchanges are subject to product availability and may involve additional shipping charges if applicable.</li>
                    </ul>

                    <h3>4. Damaged or Defective Items</h3>
                    <p>
                        We take care to ensure products are shipped in perfect condition, but issues may arise:
                    </p>
                    <ul>
                        <li>If you receive a damaged or defective item, contact us within 7 days of delivery with details and photos.</li>
                        <li>We will evaluate the claim and provide instructions for a return, replacement, or refund.</li>
                        <li>Our team may request additional information to verify the condition of the product.</li>
                    </ul>

                    <h3>5. Non-Returnable Items</h3>
                    <p>
                        Certain items cannot be returned for hygiene, safety, or customization reasons:
                    </p>
                    <ul>
                        <li>Perishable goods (e.g., food, flowers)</li>
                        <li>Personalized, custom-made, or digital items</li>
                        <li>Health and hygiene products once opened (e.g., cosmetics, skincare)</li>
                        <li>Gift cards or promotional vouchers</li>
                    </ul>

                    <h3>6. Retention of Returned Items</h3>
                    <p>
                        Returned items will be inspected and retained only as long as necessary to process the return or exchange.
                        Items not claimed within a reasonable timeframe may be disposed of securely.
                    </p>

                    <h3>7. Contact Us</h3>
                    <p>
                        For questions, concerns, or assistance regarding returns, exchanges, or refunds, please contact our customer support:
                    </p>
                    <p>
                        Online Shop Matrix<br />
                        2120 Camino Doce SW, Deming, New Mexico 88030, USA<br />
                        Phone: +1 (574) 858-0288<br />
                        Email: contact@onlineshopmatrix.com
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ReturnRefundPolicy;
